<template>
  <div name="hres31x" class="row hres31x-wrapper">
    <div class="col-md-6 menu border-bottom-color-skin-dark-10">

      <div class="panelbutton-mb" :class="{ 'hidden' : pcDisp }">
        <div class="pers-header-btn">
          <div class="icon-menu fa fa-bars color-skin"></div>
          <div class="label-btn-pers color-skin" @click="toggleMenuMobile()"> Personal Data Menu </div>
        </div>

        <div class="show-menu" v-show="menuMbDisp || pcDisp">
          <!--Menu row 1-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(1)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon01.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRRC21P1']['0'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(2)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon02.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['290'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(3)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon03.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['300'] }}
              </div>
            </div>
          </div>
          <!--Menu row 1-->
          <!--Menu row 2-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(4)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon04.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['310'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(5)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon05.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['320'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(6)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon06.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['330'] }}
              </div>
            </div>
          </div>
          <!--Menu row 2-->
          <!--Menu row 3-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(7)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon07.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['340'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(8)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon08.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['350'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(9)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon09.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['360'] }}
              </div>
            </div>
          </div>
          <!--Menu row 3-->
          <!--Menu row 4-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(10)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon10.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['370'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(11)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon11.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['380'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(12)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon12.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['390'] }}
              </div>
            </div>
          </div>
          <!--Menu row 4-->
          <!--Menu row 5-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(13)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon13.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['400'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(14)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon14.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['410'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(15)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon15.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['420'] }}
              </div>
            </div>
          </div>
          <!--Menu row 5-->
          <!--Menu row 6-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(16)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon16.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['430'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(17)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon17.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['440'] }}
              </div>
            </div>
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(18)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon18.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['450'] }}
              </div>
            </div>
          </div>
          <!--Menu row 6-->
          <!--Menu row 7-->
          <div class="rows clearfix">
            <div class="col-xs-4 pers-mb-btn" @click.stop="togglePage(19)">
              <img class="mb-btn-icon" src="../../assets/img/personal-data/profile-icon19.png">
              <div class="mb-btn-label">
                {{ labels[app.nowLang]['HRES31XC1']['460'] }}
              </div>
            </div>
          </div>
          <!--Menu row 7-->
        </div>

      </div>

      <div class="header bg-color-skin-dark-10" v-show="!menuMbDisp || pcDisp">
        <div class="image">
          <img v-if="pathImage" :src="pathImage" >
          <img v-if="!pathImage" src="~static/images/employee/no_image.png" >
        </div>
         <div class="info">
          <div class="name">{{ descCodemid }}  </div>
          <div class="underline"></div>
          <div class="corp">{{ descCodcomp }}</div>
          <div class="position">{{ descCodpos }}</div>
        </div> 
      </div>

      <div class="panelbutton" :class="{ 'hidden' : !pcDisp }">
        <!--Menu row 1-->
        <div class="row">
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-1" :class=" {'active' : generalDataActive} " @click.stop="togglePage(1)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRRC21P1']['0'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-2" :class=" {'active' : privateDataActive} " @click.stop="togglePage(2)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['290'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-3" :class=" {'active' : employDataActive} " @click.stop="togglePage(3)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['300'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-4" :class=" {'active' : incomeDataActive} " @click.stop="togglePage(4)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['310'] }}
              </div>
            </div>
          </div>
        </div>
        <!--Menu row 1-->
        <!--Menu row 2-->
        <div class="row">
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-5" :class=" {'active' : taxDataActive} " @click.stop="togglePage(5)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['320'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-6" :class=" {'active' : educateDataActive} " @click.stop="togglePage(6)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['330'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-7" :class=" {'active' : expDataActive} " @click.stop="togglePage(7)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['340'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-8" :class=" {'active' : parentDataActive} " @click.stop="togglePage(8)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['350'] }}
              </div>
            </div>
          </div>
        </div>
        <!--Menu row 2-->
        <!--Menu row 3-->
        <div class="row">
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-9" :class=" {'active' : coupleDataActive} " @click.stop="togglePage(9)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['360'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-10" :class=" {'active' : childDataActive} " @click.stop="togglePage(10)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['370'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-11" :class=" {'active' : guarantorDataActive} " @click.stop="togglePage(11)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['380'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-12" :class=" {'active' : assetDataActive} " @click.stop="togglePage(12)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['390'] }}
              </div>
            </div>
          </div>
        </div>
        <!--Menu row 3-->
         <!--Menu row 4-->
        <div class="row">
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-13" :class=" {'active' : talentDataActive} " @click.stop="togglePage(13)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['400'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-14" :class=" {'active' : trainingDataActive} " @click.stop="togglePage(14)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['410'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-15" :class=" {'active' : goodDataActive} " @click.stop="togglePage(15)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['420'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-16" :class=" {'active' : changeDataActive} " @click.stop="togglePage(16)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['430'] }}
              </div>
            </div>
          </div>
        </div>
        <!--Menu row 4-->
        <!--Menu row 5-->
        <div class="row">
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-17" :class=" {'active' : fileDataActive} " @click.stop="togglePage(17)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['440'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-18" :class=" {'active' : personrefDataActive} " @click.stop="togglePage(18)">
              <div class="label-btn-pers">
                {{ labels[app.nowLang]['HRES31XC1']['450'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3 box-btn-pers">
            <div class="btn-pers-19" :class=" {'active' : etcDataActive} " @click.stop="togglePage(19)">
              <div class="label-btn-pers" :class=" {'label-btn-pers-active' : etcDataActive} ">
                {{ labels[app.nowLang]['HRES31XC1']['460'] }}
              </div>
            </div>
          </div>
          <div class="col-sm-3">
          </div>
        </div>
        <!--Menu row 5-->

      </div>
    </div>

    <div class="col-md-6 clear-padding" v-show="!menuMbDisp || pcDisp">
      <hres31x-topic
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab1"
          :pcDisp="pcDisp"
          :page="page"
          :toggleMenuMobile="toggleMenuMobile"
          :onArrowLeft="onArrowLeft"
          :onArrowRight="onArrowRight" />

      <v-touch @swipeleft="onSwipeLeft" @swiperight="onSwipeRight">
        <hres31x-tab1 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="generalDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab1"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab2 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="privateDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab2"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab3 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="employDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab3"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab4 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="incomeDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab4"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab5 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="taxDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab5"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab6 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="educateDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab6"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab7 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="expDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab7"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab8 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="parentDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab8"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab9 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="coupleDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab9"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab10 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="childDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab10"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab11 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="guarantorDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab11"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab12 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="assetDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab12"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab13 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="talentDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab13"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton"
          :receivedHres31xdataDetailTab13Popup="receivedHres31xdataDetailTab13Popup"
          :detailTab13Popup="detailTab13Popup"
          :tab13PopupColumn="columns[app.nowLang].detailTab13Popup"
           />

        <hres31x-tab14 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="trainingDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab14"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab15 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="goodDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab15"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab16 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="changeDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab16"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab17 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="fileDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab17"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab18 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="personrefDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab18"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />

        <hres31x-tab19 class="animate-option animated" :class="{ 'slideInLeft' : swipeRight, 'slideInRight' : swipeLeft }"
          v-show="etcDataActive"
          :nowLang="app.nowLang"
          :labels="labels[app.nowLang]"
          :detail="detailTab19"
          :pcDisp="pcDisp"
          :togglePage="togglePage"
          :triggerButton="triggerButton" />
      </v-touch>
    </div>
  </div>
</template>

<script>
import * as types from 'store/modules/hres31x/mutation-types'
import * as profileimgTypes from 'store/modules/profileimg/mutation-types'
import { mapGetters, mapActions } from 'vuex'
import hres31xTopic from 'components/hres31x/topic'
import hres31xTab1 from 'components/hres31x/tab1'
import hres31xTab2 from 'components/hres31x/tab2'
import hres31xTab3 from 'components/hres31x/tab3'
import hres31xTab4 from 'components/hres31x/tab4'
import hres31xTab5 from 'components/hres31x/tab5'
import hres31xTab6 from 'components/hres31x/tab6'
import hres31xTab7 from 'components/hres31x/tab7'
import hres31xTab8 from 'components/hres31x/tab8'
import hres31xTab9 from 'components/hres31x/tab9'
import hres31xTab10 from 'components/hres31x/tab10'
import hres31xTab11 from 'components/hres31x/tab11'
import hres31xTab12 from 'components/hres31x/tab12'
import hres31xTab13 from 'components/hres31x/tab13'
import hres31xTab14 from 'components/hres31x/tab14'
import hres31xTab15 from 'components/hres31x/tab15'
import hres31xTab16 from 'components/hres31x/tab16'
import hres31xTab17 from 'components/hres31x/tab17'
import hres31xTab18 from 'components/hres31x/tab18'
import hres31xTab19 from 'components/hres31x/tab19'

export default {
  name: 'hres31x',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      swipeRight: false,
      swipeLeft: false,
      generalDataActive: true,
      privateDataActive: false,
      employDataActive: false,
      incomeDataActive: false,
      taxDataActive: false,
      educateDataActive: false,
      expDataActive: false,
      parentDataActive: false,
      coupleDataActive: false,
      childDataActive: false,
      guarantorDataActive: false,
      assetDataActive: false,
      talentDataActive: false,
      trainingDataActive: false,
      goodDataActive: false,
      changeDataActive: false,
      fileDataActive: false,
      personrefDataActive: false,
      etcDataActive: false,
      menuMbDisp: false,
      subTopic: true,
      page: 1
    }
  },
  created () {
    this.receivedHres31xColumnsLabels()
    this.receivedHres31xdataDetailTab1()
    this.receivedHres31xdataDetailTab2_19()
  },
  computed: {
    pcDisp () {
      return this.app.pcDisp
    },
    nowLang () {
      return this.app.nowLang
    },
    currentUser () {
      return this.app.currentUser
    },
    descCodemid () {
      return this.currentUser.username[this.nowLang]
    },
    descCodpos () {
      return this.currentUser.position[this.nowLang]
    },
    descCodcomp () {
      return this.currentUser.company[this.nowLang]
    },
    ...mapGetters({
      columns: types.GET_HRES31X_COLUMNS,
      labels: types.GET_HRES31X_LABELS,
      detailIndex: types.GET_HRES31X_DETAIL_INDEX,
      detailTopic: types.GET_HRES31X_DETAIL_TOPIC,
      detailTab1: types.GET_HRES31X_DETAIL_TAB1,
      detailTab2: types.GET_HRES31X_DETAIL_TAB2,
      detailTab3: types.GET_HRES31X_DETAIL_TAB3,
      detailTab4: types.GET_HRES31X_DETAIL_TAB4,
      detailTab5: types.GET_HRES31X_DETAIL_TAB5,
      detailTab6: types.GET_HRES31X_DETAIL_TAB6,
      detailTab7: types.GET_HRES31X_DETAIL_TAB7,
      detailTab8: types.GET_HRES31X_DETAIL_TAB8,
      detailTab9: types.GET_HRES31X_DETAIL_TAB9,
      detailTab10: types.GET_HRES31X_DETAIL_TAB10,
      detailTab11: types.GET_HRES31X_DETAIL_TAB11,
      detailTab12: types.GET_HRES31X_DETAIL_TAB12,
      detailTab13: types.GET_HRES31X_DETAIL_TAB13,
      detailTab14: types.GET_HRES31X_DETAIL_TAB14,
      detailTab15: types.GET_HRES31X_DETAIL_TAB15,
      detailTab16: types.GET_HRES31X_DETAIL_TAB16,
      detailTab17: types.GET_HRES31X_DETAIL_TAB17,
      detailTab18: types.GET_HRES31X_DETAIL_TAB18,
      detailTab19: types.GET_HRES31X_DETAIL_TAB19,
      detailTab13Popup: types.GET_HRES31X_DETAIL_TAB13_POPUP,
      pathImage: profileimgTypes.GET_PROFILEIMG_FILEPATH
    })
  },
  watch: {
    // 'detailIndex': {
    //   namtitlt: this.app.currentUser
    // }
  },
  methods: {
    onArrowLeft () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeLeft = true
      }
      this.triggerButton(-1)
    },
    onArrowRight () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeRight = true
      }
      this.triggerButton(1)
    },
    onSwipeRight () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeRight = true
      }
      this.triggerButton(-1)
    },
    onSwipeLeft () {
      this.swipeRight = false
      this.swipeLeft = false
      if (!this.pcDisp) {
        this.swipeLeft = true
      }
      this.triggerButton(1)
    },
    triggerButton (amountPage) {
      this.page = this.page + amountPage
      if (this.page <= 0) {
        this.page = 19
      }
      if (this.page > 19) {
        this.page = 1
      }
      this.togglePage(this.page)
    },
    togglePage (page) {
      this.page = page
      this.generalDataActive = false
      this.privateDataActive = false
      this.employDataActive = false
      this.incomeDataActive = false
      this.taxDataActive = false
      this.educateDataActive = false
      this.expDataActive = false
      this.parentDataActive = false
      this.coupleDataActive = false
      this.childDataActive = false
      this.guarantorDataActive = false
      this.assetDataActive = false
      this.talentDataActive = false
      this.trainingDataActive = false
      this.goodDataActive = false
      this.changeDataActive = false
      this.fileDataActive = false
      this.personrefDataActive = false
      this.etcDataActive = false
      this.menuMbDisp = false
      switch (page) {
        case 1:
          this.generalDataActive = true
          this.headerInfo = true
          break
        case 2:
          this.privateDataActive = true
          break
        case 3:
          this.employDataActive = true
          break
        case 4:
          this.incomeDataActive = true
          break
        case 5:
          this.taxDataActive = true
          break
        case 6:
          this.educateDataActive = true
          break
        case 7:
          this.expDataActive = true
          break
        case 8:
          this.parentDataActive = true
          break
        case 9:
          this.coupleDataActive = true
          break
        case 10:
          this.childDataActive = true
          break
        case 11:
          this.guarantorDataActive = true
          break
        case 12:
          this.assetDataActive = true
          break
        case 13:
          this.talentDataActive = true
          break
        case 14:
          this.trainingDataActive = true
          break
        case 15:
          this.goodDataActive = true
          break
        case 16:
          this.changeDataActive = true
          break
        case 17:
          this.fileDataActive = true
          break
        case 18:
          this.personrefDataActive = true
          break
        case 19:
          this.etcDataActive = true
          break
        default:
          this.generalDataActive = true
          break
      }
    },
    toggleMenuMobile () {
      this.swipeLeft = false
      this.swipeRight = false
      this.menuMbDisp = !this.menuMbDisp
    },
    ...mapActions({
      receivedHres31xColumnsLabels: types.RECEIVED_HRES31X_COLUMNS_LABELS,
      receivedHres31xdataDetailIndex: types.RECEIVED_HRES31X_DETAIL_INDEX,
      receivedHres31xdataDetailTopic: types.RECEIVED_HRES31X_DETAIL_TOPIC,
      receivedHres31xdataDetailTab1: types.RECEIVED_HRES31X_DETAIL_TAB1,
      receivedHres31xdataDetailTab2_19: types.RECEIVED_HRES31X_DETAIL_TAB2_19,
      receivedHres31xdataDetailTab13Popup: types.RECEIVED_HRES31X_DETAIL_TAB13_POPUP
    })
  },
  components: {
    hres31xTopic,
    hres31xTab1,
    hres31xTab2,
    hres31xTab3,
    hres31xTab4,
    hres31xTab5,
    hres31xTab6,
    hres31xTab7,
    hres31xTab8,
    hres31xTab9,
    hres31xTab10,
    hres31xTab11,
    hres31xTab12,
    hres31xTab13,
    hres31xTab14,
    hres31xTab15,
    hres31xTab16,
    hres31xTab17,
    hres31xTab18,
    hres31xTab19
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?464ed956